import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ok } from "@ps-bridge/ok";
import type { Ok } from "@ps-bridge/ok";
import type { OptionTs } from "@ps-bridge/interop";
import * as Option from "@utils/Option";
import App from "./App";
import { getRootContainer, logMissingRootContainer } from "./mainRoot";
import "./styles/globals.css";

const version = import.meta.env.VITE_APP_VERSION ?? "dev";
const buildTime = import.meta.env.VITE_BUILD_TIME ?? "unknown-time";

const renderIntoContainer = (container: HTMLElement): Ok => {
  console.info(`[frontend-build] version=${version} builtAt=${buildTime}`);
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );

  return ok;
};

export const mountApp = (container: OptionTs<HTMLElement>): Ok =>
  Option.fold(container, logMissingRootContainer, renderIntoContainer);

mountApp(getRootContainer());
